var e=function(e,r,n){return r in e?Object.defineProperty(e,r,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[r]=n,e};export{e as d};
//# sourceMappingURL=defineProperty-9f9de5d0.js.map
